import React from 'react';
import { Button, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Col, Form, Row } from 'react-bootstrap';

const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));
function Airline() {
    return (
        <div>
            <div>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ItemPap >
                        <Row>
                            <Col xs={1}><label>Importer</label></Col>
                            <Col xs={3}>
                                <Form.Select style={{width:'150px'}} size='sm'>
                                    <option></option>
                                    <option value="1"></option>
                                    <option value="2"></option>
                                    <option value="3"></option>
                                </Form.Select>
                            </Col>
                            <Col xs={1} >
                                <label>Job.No</label>
                            </Col>
                            <Col xs={2}>
                                <Form.Control  size='sm'/>
                            </Col>
                            <Col xs={1}>
                                <Button variant='contained' size='small'>Search</Button>
                            </Col>
                            <Col>
                            <Typography variant='subtitle1'color={'red'}>AIRLINES CHARGES</Typography>
                            </Col>
                        </Row>
                    </ItemPap>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={2}>
                    <Paper style={{textAlign:'center'}}>
                    <Typography variant='subtitle1'>No Airlines Job</Typography>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                    <StyledTableCell className='p-1'>JobNo</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                            <StyledTableRow>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Paper>
                </Grid>
                <Grid item xs={10}>
                    <Grid container>
                    <Grid item xs={9}>
                    <ItemPap>
                        <Row>
                            <Col><label>Bill Name</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col><label>Payment Type</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col><label>Rec_VoucherNo</label>
                            <Form.Control  size='sm'/>
                            </Col>
                        </Row>
                        <Row>
                            <Col><label>Bill PayedBy</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col><label>Voucher Type</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col xs={4}><label>Bill Paid Date</label>
                            <Form.Control  size='sm' type='date'/>
                            </Col>
                        </Row>
                        <Row>
                            <Col><label>Bill PaidTo</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col><label>Printed Type</label>
                            <Form.Select size='sm'>
                                <option></option>
                            </Form.Select>
                            </Col>
                            <Col><label>Bill Amount</label>
                            <Form.Control  size='sm'/>
                            </Col>
                        </Row>
                        <Row>
                        <Col xs={3}><label>Remarks</label></Col>
                        </Row>
                        <Row style={{marginLeft:'1%'}}>
                          <Col xs={3}><Form.Control size='sm' /></Col>
                            <Col xs={2}><Button variant='contained' size='small'>Save</Button></Col>
                            <Col xs={2}><Button variant='contained' size='small'>Update</Button></Col>
                            <Col xs={2}><Button variant='contained' size='small'>Delete</Button></Col>
                            <Col xs={1}><Button variant='contained' size='small'>Refresh</Button></Col>
                        </Row>
                    </ItemPap>
                    </Grid>
                    <Grid item xs={3}>
                    <Paper style={{textAlign:'center'}}>
                    <Typography variant='subtitle1'>Airlines Job</Typography>
                    <TableContainer sx={{ maxHeight: 210}}>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                    <StyledTableCell className='p-1'>JobNo</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                            <StyledTableRow>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Paper>
                </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                    <Paper style={{textAlign:'center',height:'210px'}}>
                        <Typography variant='subtitle1' color={'red'}>Airlines Billing Details</Typography>
                    <TableContainer sx={{ maxHeight: 200}}>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1'>JobNo</StyledTableCell>
                                    <StyledTableCell className='p-1'>PaidBy</StyledTableCell>
                                    <StyledTableCell className='p-1'>PaidTo</StyledTableCell>
                                    <StyledTableCell className='p-1'>PaidDate</StyledTableCell>
                                    <StyledTableCell className='p-1'>PaymentType</StyledTableCell>
                                    <StyledTableCell className='p-1'>VoucherType</StyledTableCell>
                                    <StyledTableCell className='p-1'>PrintedType</StyledTableCell>
                                    <StyledTableCell className='p-1'>BillType</StyledTableCell>
                                    <StyledTableCell className='p-1'>BillName</StyledTableCell>
                                    <StyledTableCell className='p-1'>Amount</StyledTableCell>
                                    <StyledTableCell className='p-1'>Remarks</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                            <StyledTableRow>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                    <StyledTableCell>1</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                    <StyledTableCell>10006543</StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Paper>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                <Paper>
                    <div style={{textAlign:'center'}}>
                        <Typography variant='subtitle1' color='red'>Job Entry Details</Typography>
                    </div>
                    <Row>
                        <Col>
                        <Typography variant='subtitle1'>Job No</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>Importer</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>OriginCountry</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Typography variant='subtitle1'>MAWB No</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>Address</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>OriginPort</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Typography variant='subtitle1'>ImporterName</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'> </Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>ClearancePort</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Typography variant='subtitle1'>Importer Code</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>Transit Type</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>ArrivelDate</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Typography variant='subtitle1'>ImportState</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>Airlines Name</Typography>
                        </Col>
                        <Col>
                        <Typography variant='subtitle1'>HAWB No</Typography>
                        </Col>
                    </Row>
                </Paper>
                </Grid>
                </Grid>
                
            </Grid>
            </div>
        </div>
      )
}

export default Airline